import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { HiOutlineCheck } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";

import { EstimatedQuoteStatus } from "../../../../../util/enums";
import { Icon, Title, Wrapper, Text, Content } from "./styles";

interface ResponseTemplateProps {
  type: string;
}

export const ResponseTemplate = (props: ResponseTemplateProps) => {
  const { type } = props;
  const { t: translate } = useTranslation();

  const returnTemplateStatus = useMemo(() => {
    if (type === EstimatedQuoteStatus.DECLINED) return translate("estimateQuoteHasBeenDeclined");
    if (type === EstimatedQuoteStatus.APPROVED) return translate("estimateQuoteHasBeenApproved")

    return translate("thisEstimateQuoteHasBeenSentToReview");
  }, [type])

  const returnTemplateText = useMemo(() => {
    if (type === EstimatedQuoteStatus.APPROVED) return translate("thankYouSoMuchForApprovingTheEstimateWithUs");
    if (type === EstimatedQuoteStatus.DECLINED) return translate("weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell");

    return translate("weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly")
  }, [type])

  const returnSecondText = useMemo(() => {
    if (type === EstimatedQuoteStatus.DECLINED) return translate("shipeeziWillAlwaysBeHereWithYou");

    return "";
  }, [type])

  return (
    <Wrapper>
      <Icon type={type}>
        {type === EstimatedQuoteStatus.DECLINED ? (
          <IoMdClose />
          ) : (
          <HiOutlineCheck />
        )}
      </Icon>

      <Content>
        <Title type={type} aria-label="titleStatus">{returnTemplateStatus}</Title>

        <Text>{returnTemplateText}</Text>
        <Text className="mt20">{returnSecondText}</Text>

    
      </Content>


    </Wrapper>
  );

}
